import { useMutation, useQueryClient, useQuery } from 'react-query';
import { useParams } from 'react-router-dom';

import api from 'api';

export function GETMissions({ queryKey }) {
  const [, params] = queryKey;
  return api.get.missions(params);
}

export function GETSingleMission({ queryKey }) {
  const [, missionId, params] = queryKey;
  return api.get.singleMission(missionId, params);
}

export function GETSingleMissionStats({ queryKey }) {
  const [, missionId, params] = queryKey;
  return api.get.singleMissionStats(missionId, params);
}

export function PATCHAdminSingleMissionValidate(missionId) {
  return () => api.patch.adminSingleMissionValidate(missionId);
}

export function PATCHSingleMissionValidate(missionId) {
  return () => api.patch.singleMissionValidate(missionId);
}

/**
 * Missions queries
 */

export function useGetMissions(params = {}, options = {}) {
  return useQuery(['missions', params], GETMissions, options);
}

export function useGetSingleMission(params = {}) {
  const { missionId } = useParams();
  return useQuery(['single mission', missionId, params], GETSingleMission, {
    staleTime: 5 * 60 * 1000,
  });
}

export function useGetSingleMissionStats(params = {}, options = {}) {
  const { missionId } = useParams();
  return useQuery(['single mission stats', missionId, params], GETSingleMissionStats, options);
}

/**
 * Missions mutations
 */

export function usePatchAdminSingleMissionValidate() {
  const { missionId } = useParams();
  const queryClient = useQueryClient();
  return useMutation(PATCHAdminSingleMissionValidate(missionId), {
    onSuccess: () => {
      queryClient.invalidateQueries('single mission');
    },
  });
}

export function usePatchSingleMissionValidate() {
  const { missionId } = useParams();
  const queryClient = useQueryClient();
  return useMutation(PATCHSingleMissionValidate(missionId), {
    onSuccess: () => {
      queryClient.invalidateQueries('single mission');
    },
  });
}
